'use es6';

import I18n from 'I18n';
import { memo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingMessage = /*#__PURE__*/memo(() => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBlockStart: "1000",
    paddingBlockStart: "1000",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h3",
      marginBlockStart: "1000",
      paddingBlockStart: "1000",
      children: I18n.text('message.loading')
    }), /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "medium"
    })]
  });
});
export default LoadingMessage;